import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { quillEditor } from 'vue-quill-editor';
import quillConfig from '@/views/components/editor/quill-config.js';
import previewModal from '@/views/claim/demageManage/previewModal.vue';
import { uploadFile, sceneConfigAdd, sceneConfigEdit } from '../request';
import variable from './variable.vue';
import { cryptoDecrypt } from '@/utils/aes';
import mail from './mail.vue';
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    language: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => ({})
    },
    variables: {
      type: Object,
      default: () => {}
    },
    sceneListId: {
      type: String | Number,
      default: ''
    }
  },
  data() {
    return {
      form: {
        title: '',
        fileContent: '',
        fileList: []
      },
      fileList: [],
      previewVisible: false,
      previewSrc: '',
      btnShow: 2,
      isEdit: false,
      action: uploadFile,
      quillOption: quillConfig,
      fileType: '',
      loading: false,
      currentPreviewIndex: 0,
      attachmentVariable: [],
      copyItem: null
    };
  },
  watch: {
    item: {
      handler(val) {
        this.form = {
          title: '',
          fileContent: '',
          fileList: []
        };
        this.copyItem = JSON.parse(JSON.stringify(val));
        if (val && !val.id) {
          //第一次新增
          this.btnShow = 1;
          this.isEdit = true;
        }
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    quillEditor,
    previewModal,
    variable,
    mail
  },
  methods: {
    setFormData(resetItem) {
      this.form.fileList = resetItem.uploadFiles ? JSON.parse(resetItem.uploadFiles) : [];
      this.form.fileContent = resetItem.content || '';
      this.form.title = resetItem.title || '';
    },
    updateDataVariable(resetItem) {
      var _resetItem$annexVaria;
      let variables = ((_resetItem$annexVaria = resetItem.annexVariable) === null || _resetItem$annexVaria === void 0 ? void 0 : _resetItem$annexVaria.split(',')) || [];
      this.attachmentVariable.forEach(item => {
        if (variables.includes(item.mark)) {
          item.isCheck = true;
        } else {
          item.isCheck = false;
        }
      });
      this.attachmentVariable = [...this.attachmentVariable];
    },
    changeCheck(item) {
      // 附件变量点击切换
      this.$set(item, 'isCheck', !item.isCheck);
    },
    handleChange(info) {
      if (info.file.status === 'done') {
        if (info.file.response.code != 200) {
          this.$message.error(info.file.response.message);
          this.form.fileList[this.form.fileList.length - 1].status = 'error';
        }
      }
      let fileList = info.fileList;
      this.form.fileList = fileList.map(file => {
        if (file.response) {
          file.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        }
        let obj = {
          uid: file.uid,
          name: file.name,
          url: file.url || ''
        };
        return obj;
      });
    },
    checkFileUploadComplate(fileList) {
      let status = true;
      fileList && Array.isArray(fileList) && fileList.forEach(item => {
        if (item.status !== 'done') {
          status = false;
        }
      });
      return status;
    },
    saveForm() {
      let childForm = this.$refs.mailForm;
      childForm === null || childForm === void 0 || childForm.$refs.ruleForm.validate(valid => {
        if (valid) {
          var _this$form$title, _this$form$fileConten;
          this.form = this.$refs.mailForm.form;
          if (this.form.fileList && !this.checkFileUploadComplate(this.form.fileList)) {
            return this.$message.error(this.$t('文件上传中，请稍后再试'));
          }
          let fileList = [];
          this.form.fileList.forEach(item => {
            let obj = {
              uid: item.uid,
              name: item.name,
              url: item.url || '',
              status: item.status
            };
            fileList.push(obj);
          });
          // this.form.fileList.length > 0 ? JSON.stringify(this.form.fileList) : '';
          let annexVariable = [];
          let attachmentVariable = this.$refs.mailForm.attachmentVariable;
          attachmentVariable.forEach(item => {
            if (item.isCheck) {
              annexVariable.push(item.mark);
            }
          });
          this.form.variables = (annexVariable === null || annexVariable === void 0 ? void 0 : annexVariable.length) > 0 ? annexVariable.join(',') : '';
          let params = {
            sceneListId: this.sceneListId,
            title: ((_this$form$title = this.form.title) === null || _this$form$title === void 0 ? void 0 : _this$form$title.trim()) || '',
            content: ((_this$form$fileConten = this.form.fileContent) === null || _this$form$fileConten === void 0 ? void 0 : _this$form$fileConten.trim()) || '',
            uploadFiles: (fileList === null || fileList === void 0 ? void 0 : fileList.length) > 0 ? JSON.stringify(fileList) : '',
            type: this.type,
            annexVariable: (annexVariable === null || annexVariable === void 0 ? void 0 : annexVariable.length) > 0 ? annexVariable.join(',') : '',
            language: this.language,
            isSystemTemplate: 1,
            code: ''
          };
          if (this.copyItem.id) {
            //编辑
            params.sceneConfigId = this.copyItem.id;
            this.loading = true;
            sceneConfigEdit(params).then(res => {
              if (res.sceneConfigId) {
                this.$message.success(this.$t('保存成功'));
                this.updateData();
                this.saveStatusUpdate();
              }
            }).finally(() => {
              this.loading = false;
            });
          } else {
            //新增
            this.loading = true;
            sceneConfigAdd(params).then(res => {
              if (res.sceneConfigId) {
                this.$message.success(this.$t('保存成功'));
                this.$set(this.copyItem, 'id', res.sceneConfigId);
                this.updateData();
                this.saveStatusUpdate();
              }
            }).finally(() => {
              this.loading = false;
            });
          }
        } else {
          return false;
        }
      });
    },
    saveStatusUpdate() {
      this.btnShow = 2;
      this.isEdit = false;
    },
    updateData() {
      var _this$form$fileList;
      //保存后更新状态
      let uploadFiles = (_this$form$fileList = this.form.fileList) !== null && _this$form$fileList !== void 0 && _this$form$fileList.length ? JSON.stringify(this.form.fileList) : '';
      this.$set(this.copyItem, 'title', this.form.title);
      this.$set(this.copyItem, 'content', this.form.fileContent);
      this.$set(this.copyItem, 'uploadFiles', uploadFiles);
      this.$set(this.copyItem, 'annexVariable', this.form.variables);
    },
    editForm() {
      this.btnShow = 3;
      this.isEdit = true;
    },
    cancelForm() {
      this.$refs.mailForm.cancelForm();
      this.saveStatusUpdate();
    },
    cancelPre() {
      this.previewVisible = false;
      this.previewSrc = '';
      this.currentPreviewIndex = 0;
    }
  }
};